
import { IEsDataCompanyGetDTO } from "../../coreapi-dto/dirs/esDataCompany";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import BaseCoreApiRequest from "../baseCoreApiRequest";
import { CoreApiResponse, IRequestEventHandler } from "../common";

class EsDataCompanyRequest extends BaseCoreApiRequest {

    protected _routePrefix: string
    protected _eventHandler: IRequestEventHandler;
    protected readonly _token: string

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl)
        this._routePrefix = 'EsData/Company'
        this._eventHandler = eventHandler
        this._token = token
    }

    sync(callback?: (e: CoreApiResponse<null>) => void) {
        super.post2<null>(`${this._baseUrl}/${this._routePrefix}/sync`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                callback?.(e)
            },
        );
    }

    status(callback?: (e: CoreApiResponse<IEsDataCompanyGetDTO>) => void) {
        super.get<IEsDataCompanyGetDTO>(`${this._baseUrl}/${this._routePrefix}/status`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                callback?.(e);
            },
        );
    }

}
export default EsDataCompanyRequest